import { render } from "./StatusField.vue?vue&type=template&id=6f2c5e94"
import script from "./StatusField.vue?vue&type=script&lang=js"
export * from "./StatusField.vue?vue&type=script&lang=js"

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"StatusField.vue"]])

export default __exports__